// Constants
let APP_CONST = {};

APP_CONST.LAYOUT_FULL    = 'full';
APP_CONST.LAYOUT_PARTIAL = 'partial';

// Alert constants
APP_CONST.ALERT_TYPE_DANGER  = 'danger';
APP_CONST.ALERT_TYPE_INFO    = 'info';
APP_CONST.ALERT_TYPE_SUCCESS = 'success';
APP_CONST.ALERT_TYPE_WARNING = 'warning';

APP_CONST.ALERT_CLASSES = {};
APP_CONST.ALERT_CLASSES[APP_CONST.ALERT_TYPE_DANGER]  = 'alert-danger';
APP_CONST.ALERT_CLASSES[APP_CONST.ALERT_TYPE_INFO]    = 'alert-info';
APP_CONST.ALERT_CLASSES[APP_CONST.ALERT_TYPE_SUCCESS] = 'alert-success';
APP_CONST.ALERT_CLASSES[APP_CONST.ALERT_TYPE_WARNING] = 'alert-warning';

// Btn constants
APP_CONST.BTN_TYPE_DANGER  = 'danger';
APP_CONST.BTN_TYPE_DEFAULT = 'default';
APP_CONST.BTN_TYPE_PRIMARY = 'primary';
APP_CONST.BTN_TYPE_INFO    = 'info';
APP_CONST.BTN_TYPE_SUCCESS = 'success';
APP_CONST.BTN_TYPE_WARNING = 'warning';

APP_CONST.BTN_CLASSES = {};
APP_CONST.BTN_CLASSES[APP_CONST.BTN_TYPE_DANGER]  = 'btn-danger';
APP_CONST.BTN_CLASSES[APP_CONST.BTN_TYPE_DEFAULT] = 'btn-default';
APP_CONST.BTN_CLASSES[APP_CONST.BTN_TYPE_PRIMARY] = 'btn-primary';
APP_CONST.BTN_CLASSES[APP_CONST.BTN_TYPE_INFO]    = 'btn-info';
APP_CONST.BTN_CLASSES[APP_CONST.BTN_TYPE_SUCCESS] = 'btn-success';
APP_CONST.BTN_CLASSES[APP_CONST.BTN_TYPE_WARNING] = 'btn-warning';

APP_CONST.BTN_SIZE_LG = 'lg';
APP_CONST.BTN_SIZE_SM = 'sm';

// Field constants
APP_CONST.FIELD_TYPE_EMAIL = 'email';
APP_CONST.FIELD_TYPE_PASSWORD = 'password';
APP_CONST.FIELD_TYPE_TEXT = 'text';
APP_CONST.FIELD_TYPE_TEL = 'tel';
APP_CONST.FIELD_TYPE_TOGGLE = 'toggle';
APP_CONST.FIELD_TYPE_SELECT = 'select';

// Flash Keys
APP_CONST.FLASH = {
    SUCCESSFUL_PASSWORD_CHANGE: 'successful_password_change',
};


export { APP_CONST };
export default APP_CONST;